<style lang="less">
  @import "./SimCard.less";
</style>

<template>
  <div class="sim-card">

    <div class="sim-card-user">
      <img :src="userHeadUrl" alt="">
      <label>{{userWxName || '您好'}}</label>
    </div>

    <div class="sim-card-info">
      <p>当前IMEI：<span>{{nowImei}}</span></p>
      <p>当前ICCID：<span>{{nowIccid}}</span></p>
      <p>SIM卡状态：<span :class="loadingSimCard?'':simStateText==='已激活'?'green-color':'red-color'">{{simIsXjCard?simStateText:'非途云卡'}}</span></p>
      <p>SIM卡套餐：<van-button plain type="info" size="small" @click="showPurchaseFn" v-if="nowIccid && simIsXjCard && !loadingSimCard">购买记录</van-button></p>
      <div v-if="nowIccid && simIsXjCard && !loadingSimCard" class="meal-title">不限流量畅用 <span>{{nowMealEndTime}}截止</span></div>
      <div v-if="!nowIccid || !simIsXjCard || loadingSimCard">{{!nowIccid?'该设备未插卡':loadingSimCard?'查询中...':'暂不支持非途云卡查询'}}</div>
    </div>

    <div class="sim-card-meal">
      <div class="sim-card-list clear" v-for="(item, index) in simMealList" :key="index">
        <img v-if="index===0" src="../../../assets/images/sim/ic_sim_one.png" alt="套餐">
        <img v-if="index===1" src="../../../assets/images/sim/ic_sim_two.png" alt="套餐">
        <img v-if="index===2" src="../../../assets/images/sim/ic_sim_there.png" alt="套餐">
        <img v-if="index>2" src="../../../assets/images/sim/ic_sim_list.png" alt="套餐">
        <div><p class="size-middle">{{item.title}}</p><span>{{item.pre ? item.pre + '元/天' : '特惠流量'}}</span></div>
        <van-button type="info" size="small" @click="buyPackagesFn(item._id, item.title)">购买</van-button>
        <label class="size-big">{{item.price/100}}元</label>
        <img v-if="index===0" class="sim-hot" src="../../../assets/images/sim/ic_sim_hot.png" alt="">
      </div>
    </div>

    <!--购买记录-->
    <van-popup v-model="showPurchase" round closeable position="bottom" :style="{ height: + purchaseList.length>3?'80%':'70%' }" @click-overlay="clickOverlay">
      <!--2.1.2版本中popup无关闭图标,需要自定义-->
      <div class="popup-title">套餐购买记录</div>
      <!--<div class="popup-title">套餐购买记录<van-icon name="close" size="1.5rem" color="#aaaaaa" @click="closePopupFn"/></div>-->
      <div class="popup-con">
        <div class="purchase-list" v-for="(item, index) in purchaseList" :key="index">
          <p>套餐名称：{{item.title}}<span class="purchase-list-price green-color">￥{{item.price/100}}</span></p>
          <p>流量时长：{{item.effectiveText}}</p>
          <p>购买账号：{{item.mobileText}}</p>
          <p>购买时间：{{item.buyTime}}</p>
          <p>订单号：{{item.order_id}}</p>
        </div>
        <div v-if="purchaseList.length>0" class="purchase-list-no-more gray-color">{{purchaseList.length >= 30 ? '最多查询最近30条记录' : '没有更多记录了'}}</div>
        <div v-if="purchaseList.length===0" class="no-data"><p>暂无购买记录</p></div>
      </div>
    </van-popup>

  </div>

</template>

<script>
import SimCard from './SimCard.js'
export default {
  ...SimCard
}
</script>
